enum PageStatus {
    PUBLISHED = 'published',
    DRAFT = 'draft',
    PRIVATE = 'private',
}

export { PageStatus };
